import allotment from './allotment'
import document from './document'
import order from './order'
import orderRequest from './order-request'
import route from './route'
export default {
  order,
  orderRequest,
  allotment,
  document,
  route
} as { [key: string]: any }
